const getTenant = () => {
  var pathPiece = window.location.pathname.split('/')[1];
  pathPiece = pathPiece.toLowerCase();
  if (pathPiece === 'login' || pathPiece === 'home' || pathPiece === 'no_tenant' || pathPiece === 'dsconnected' || pathPiece === 'dssigned') {
    return '';
  }
  return pathPiece;
};

export default getTenant;